export default __webpack_public_path__ + "static/9-3bd7e9d975a48ce95895a727fb798b54.jpg";